import { render } from "./MySitesMenu.vue?vue&type=template&id=75d5cbe3"
import script from "./MySitesMenu.vue?vue&type=script&lang=ts"
export * from "./MySitesMenu.vue?vue&type=script&lang=ts"

import "./MySitesMenu.vue?vue&type=style&index=0&id=75d5cbe3&lang=scss"
script.render = render

export default script